var themes_config = {
  theme_robseeco: JSON.parse( process.env.VUE_APP_THEME_ROBSEECO),
  theme_growmark: JSON.parse( process.env.VUE_APP_THEME_GROWMARK),
  theme_winfield: JSON.parse( process.env.VUE_APP_THEME_WINFIELD),
  theme_paplus: JSON.parse( process.env.VUE_APP_THEME_PAPLUS),
  theme_syngenta: JSON.parse( process.env.VUE_APP_THEME_SYNGENTA),
  theme_syngenta_new: JSON.parse( process.env.VUE_APP_THEME_SYNGENTA_NEW)
};

module.exports = themes_config;
